<template>
  <Button variant="link" size="small" class="!text-xs sm:!text-sm mb-2" :on-click="handleClick">
    {{ $t('text-clear-filters') }}
  </Button>
</template>

<script setup>
import _ from 'lodash-es';
import Button from "@components/ui/button";

const props = defineProps({
  preservePostCategory: {
    type: Boolean,
    default: false
  }
});

const route = useRoute();

const handleClick = async () => {
  await navigatorTo({
    path: route.path,
    query: _.pick(route.query, [
      'sort',
      'direction',
      ...(props.preservePostCategory ? ['idPostCategory'] : [])
    ])
  });
}

</script>
